module.exports = __webpack_public_path__ + "img/hostingwerft.82715540.png";